import React from 'react';
import { DateBox } from 'devextreme-react';
import DataGrid, { Column, Paging, Lookup, Editing, RequiredRule, Scrolling, Selection, FilterRow } from 'devextreme-react/data-grid';
import { SelectBox } from 'devextreme-react';
import { TimeZoneInts, Times } from './Data.js';
import ArrayStore from 'devextreme/data/array_store';
import { childrenServices } from '../../services/children.service';
import { surveyServices } from '../../services/survey.service';
import notify from 'devextreme/ui/notify';
import DropDownBox from "devextreme-react/drop-down-box";

const dropDownOptions = { width: 200 };
const daysOfWeek = [
  {
    Value: "0",
    Name: "Sunday",
  },
  {
    Value: "1",
    Name: "Monday",
  },
  {
    Value: "2",
    Name: "Tuesday",
  },
  {
    Value: "3",
    Name: "Wednesday",
  },
  {
    Value: "4",
    Name: "Thusday",
  },
  {
    Value: "5",
    Name: "Friday",
  },
  {
    Value: "6",
    Name: "Saturday",
  },
];

export class Survey extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userChildren: [],
      userId: localStorage.getItem('userId'),
      standardQuestions: [],
      userQuestions: [],
      surveyTimes: [],
      startTime: null,
      endTime: null,
      timeZone: '',
    };

    this.timeZoneRef = React.createRef();
    this.startTimeRef = React.createRef();
    this.endTimeRef = React.createRef();

    this.setTimes = () => {
      this.startTimeSelect.option('value', this.state.startTime);
      this.endTimeSelect.option('value', this.state.endTime);
      this.timeZoneSelect.option('value', this.state.timeZone);
    };

    this.onUpdateStandardQuestions = this.updateStandardQuestions.bind(this);

    this.onUserQuestionRowUpdating = this.userQuestionUpdate.bind(this);
    this.onUserQuestionRowRemoving = this.userQuestionRemove.bind(this);
    this.onUserQuestionRowInserting = this.userQuestionInsert.bind(this);

    this.onStartTimeChanged = this.startTimeChanged.bind(this);
    this.onEndTimeChanged = this.endTimeChanged.bind(this);
    this.onTimeZoneChanged = this.timeZoneChanged.bind(this);

    this.onSurveyTimeRowUpdating = this.updateSurveyTime.bind(this);

    this.now = new Date();
    this.data = new ArrayStore({
      data: TimeZoneInts,
      key: 'value'
    });

    //get all standard questions
    surveyServices.getStandardQuestions(this.state.userId).then(
      data => {
        this.setState({ standardQuestions: data });
      },
      error => {
        notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
      }
    );

    //get all user survey questions
    surveyServices.getUserQuestionsByUserId(this.state.userId).then(
      data => {
        this.setState({ userQuestions: data });
      },
      error => {
        notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
      }
    );

    //get all survey times
    this.refreshSurveyTime();
    
    childrenServices.getByUserId(this.state.userId).then(
      data => {
        if (data.length > 0) {
          //data.push({ 'firstName': 'All My Messages', 'lastName': '', 'childrenId': 'All' });
          this.setState({ userChildren: data });
        }
      },
      error => {
        notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
      }
    );
  }

  get startTimeSelect() {
    return this.startTimeRef.current.instance;
  }

  get endTimeSelect() {
    return this.endTimeRef.current.instance;
  }

  get timeZoneSelect() {
    return this.timeZoneRef.current.instance;
  }

  //Start Standard questions
  updateStandardQuestions(event) {
    let { standardQuestions } = this.state;
    var newData = event.newData;
    newData.userId = this.state.userId;
    standardQuestions = standardQuestions.map(question => (question.questionId === event.key ? { ...question, ...newData } : question));
    var changedRow;
    standardQuestions.forEach(question => {
      if (event.key === question.questionId)
        changedRow = question;
    });
    if (changedRow) {
      changedRow.questionType = '0';
      surveyServices.updateUserQuestion(changedRow).then(
        () => {
          notify({ position: 'top right', message: 'Updated successfully', type: 'success', maxWidth: 200 });
          this.refreshSurveyTime();
        },
        error => {
          notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
          this.refreshSurveyTime();
        }
      );
    }
  }

  //Start Grid user survey question handler
  userQuestionInsert(event) {
    var addedRow = event.data;
    addedRow.userId = this.state.userId;
    surveyServices.addUserQuestion(addedRow).then(
      response => {
        if (response) {
          notify({ position: 'top right', message: 'Added successfully', type: 'success', maxWidth: 200 });
          this.refreshSurveyTime();
        }
      },
      error => {
        notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
        this.refreshSurveyTime();
      }
    );
  }

  userQuestionUpdate(event) {
    let { userQuestions } = this.state;
    var newData = event.newData;
    userQuestions = userQuestions.map(question => (question.questionId === event.key ? { ...question, ...newData } : question));
    var changedRow;
    userQuestions.forEach(question => {
      if (event.key === question.questionId)
        changedRow = question;
    });
    if (changedRow) {
      surveyServices.updateUserQuestion(changedRow).then(
        () => {
          notify({ position: 'top right', message: 'Updated successfully', type: 'success', maxWidth: 200 });
          this.refreshSurveyTime();
        },
        error => {
          notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
          this.refreshSurveyTime();
        }
      );
    }
  }

  userQuestionRemove(event) {
    surveyServices.deleteUserQuestion(event.key).then(
      response => {
        if (response) {
          notify({ position: 'top right', message: 'Deleted successfully', type: 'success', maxWidth: 200 });
          this.refreshSurveyTime();
        }
      },
      error => {
        notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
        this.refreshSurveyTime();
      }
    );
  }
  //End Grid user survey question handler

  //Start Survey Time
  startTimeChanged(e) {
    this.setState({ startTime: e.value });
  }

  endTimeChanged(e) {
    this.setState({ endTime: e.value });
  }

  timeZoneChanged(e) {
    this.setState({ timeZone: e.value });
  }

  updateSurveyTime(event) {
    let { surveyTimes } = this.state;

    if (this.state.startTime == null) {
      notify({ position: 'top right', message: "Failed: Start time is required.", type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
    }
    else if (this.state.endTime == null) {
      notify({ position: 'top right', message: "Failed: End time is required.", type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
    }
    else if (this.state.startTime > this.state.endTime) {
      notify({ position: 'top right', message: "Failed: End time must be greater than start time.", type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
    }
    else if (this.state.timeZone == null) {
      notify({ position: 'top right', message: "Failed: Time zone is required.", type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
    }
    else {
      var newData = Object.assign({}, event.newData);
      newData.userTimeZone = this.state.timeZone;
      newData.startSurveyAt = this.state.startTime.getHours() + ":" + this.state.startTime.getMinutes();
      newData.endSurveyAt = this.state.endTime.getHours() + ":" + this.state.endTime.getMinutes();

      surveyTimes = surveyTimes.map(question => (question.questionId === event.key ? { ...question, ...newData } : question));
      var changedRow;
      surveyTimes.forEach(question => {
        if (event.key === question.questionId)
          changedRow = question;
      });
      if (changedRow) {
        var days = '';
        changedRow.daysOfWeek.forEach(element => {
          days += element + ',';
        });
        changedRow.daysOfWeek = days.replace(/,\s*$/, "");

        var childIds='';
        changedRow.childrenId.forEach(element => {
          childIds+=element+',';
        });
        changedRow.childrenId=childIds.replace(/,\s*$/, "");

        changedRow.userId = this.state.userId;
        surveyServices.updateSurveyTime(changedRow).then(
          () => {
            notify({ position: 'top right', message: 'Updated successfully', type: 'success', maxWidth: 200 });
          },
          error => {
            notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
          }
        );
      }
    }
  }

  refreshSurveyTime() {
    surveyServices.getUserSurveyTimeByUserIdAndChildId(this.state.userId, null).then(
      data => {
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          if (element.startSurveyAt != null) {
            this.setState({ startTime: new Date("2020-05-29 " + element.startSurveyAt) });
            this.setState({ endTime: new Date("2020-05-29 " + element.endSurveyAt) });
            this.setState({ timeZone: element.userTimeZone });
            this.setTimes();
            //break;
          }
          //convert daysOfWeek to array
          if (element.daysOfWeek != null) {
            element.daysOfWeek = element.daysOfWeek.split(",");
          }

          //convert childrenId to array
          if(element.childrenId!=null)
          {
            element.childrenId = element.childrenId.split(",");
          }
        };
        this.setState({ surveyTimes: data });
      },
      error => {
        notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
      }
    );
  }

  cellTemplate(container, options) {
    var noBreakSpace = '\u00A0'
    if (options && options.value) {
      options.value = options && Array.isArray(options.value) ? options.value : options.value.split(',')
      var text = (options.value || []).map(element => {
        return options.column.lookup.calculateCellValue(element);
      }).join(', ');
      container.textContent = text || noBreakSpace;
      container.title = text;
    }

  }

  render() {
    return (
      <div>
        <h6>Please select any sample question that you want to receive in your survey question.</h6>
        <DataGrid
          dataSource={this.state.standardQuestions}
          showBorders={true}
          keyExpr="questionId"
          onRowUpdating={this.onUpdateStandardQuestions}
        >
          <Paging defaultPageSize={10} />
          <Editing
            mode={'batch'}
            allowUpdating={true}
            selectTextOnEditStart={true}
            startEditAction="click"
          />
          {/* <Column dataField="questionId" caption="Question ID"/> */}
          <Column dataField="questionBody" caption="Question" allowEditing={false} />
          <Column dataField="isQuestionActive" caption="Active" dataType={'boolean'}  width={100}/>
        </DataGrid>
        <br />

        <h6>Your can add your own Survey Questions</h6>
        <DataGrid
          dataSource={this.state.userQuestions}
          showBorders={true}
          keyExpr="questionId"
          onRowUpdating={this.onUserQuestionRowUpdating}
          onRowRemoving={this.onUserQuestionRowRemoving}
          onRowInserting={this.onUserQuestionRowInserting}
        >
          <Paging defaultPageSize={10} />
          <Editing
            mode={'batch'}
            allowAdding={true}
            allowUpdating={true}
            allowDeleting={true}
            selectTextOnEditStart={true}
            startEditAction="click"
          />
          {/* <Column dataField="questionId" caption="Question ID"/> */}
          <Column dataField="questionBody" caption="Question" />
          <Column dataField="isQuestionActive" caption="Active" dataType={'boolean'}  width={100}/>
        </DataGrid>
        <br />
        <h6>When do you want to receive survey questions?</h6>
        <div className="dx-field" style={{ width: "30%" }}>
          <div className="dx-field-label">Start Time of survey</div>
          <div className="dx-field-value" style={{ width: "53%" }}>
            <DateBox type="time" onValueChanged={this.onStartTimeChanged} ref={this.startTimeRef} />
          </div>
        </div>
        <div className="dx-field" style={{ width: "30%" }}>
          <div className="dx-field-label">End Time of survey</div>
          <div className="dx-field-value" style={{ width: "53%" }}>
            <DateBox type="time" onValueChanged={this.onEndTimeChanged} ref={this.endTimeRef} />
          </div>
        </div>
        <div className="dx-field" style={{ width: "55%" }}>
          <div className="dx-field-label" style={{ width: "19%" }}>Time zone</div>
          <div className="dx-field-value" style={{ width: "81%" }}>
            <SelectBox dataSource={this.data}
              displayExpr="label"
              valueExpr="value"
              defaultValue={this.state.timeZone}
              onValueChanged={this.onTimeZoneChanged}
              ref={this.timeZoneRef} />
          </div>
        </div>

        <DataGrid
          dataSource={this.state.surveyTimes}
          showBorders={true}
          keyExpr="questionId"
          onRowUpdating={this.onSurveyTimeRowUpdating}
        >
          <Paging defaultPageSize={10} />
          <Editing
            mode={'batch'}
            allowUpdating={true}
            selectTextOnEditStart={true}
            startEditAction="click"
          />

          {/* <Column dataField="questionId" caption="Question ID"/> */}
          <Column dataField="questionBody" caption="Question" width={400} allowEditing={false}/>
          <Column dataField="askQuestionAt" caption="Ask Question at" width={100}>
            <Lookup dataSource={Times} valueExpr="value" displayExpr="text" />
          </Column>
          <Column
            dataField="childrenId"
            allowSorting={false}
            editCellComponent={ChildrenDropDownBoxComponent}
            cellTemplate={this.cellTemplate}
            caption="Children"
          >
            <Lookup
              dataSource={this.state.userChildren}
              displayExpr="firstName"
              valueExpr="childrenId"
            />
            <RequiredRule />
          </Column>
          <Column
            dataField="daysOfWeek"
            allowSorting={false}
            editCellComponent={DaysOfWeekDropDownBoxComponent}
            cellTemplate={this.cellTemplate}
            caption="Day of the week to ask"
          >
            <Lookup
              dataSource={daysOfWeek}
              displayExpr="Name"
              valueExpr="Value"
            />
            <RequiredRule />
          </Column>
          <Column dataField="isRandom" key="childrendId" caption='Is Random' dataType={'boolean'} width={80} />
        </DataGrid>
      </div>
    );
  }
}

class ChildrenDropDownBoxComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValue: props.data.value || [],
    };
    this.dropDownBoxRef = React.createRef();
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.syncDataGridSelection = this.syncDataGridSelection.bind(this);
    this.contentRender = this.contentRender.bind(this);
  }

  contentRender() {
    return (
      <DataGrid
        dataSource={this.props.data.column.lookup.dataSource}
        remoteOperations={true}
        keyExpr="childrenId"
        selectedRowKeys={this.state.currentValue}
        hoverStateEnabled={true}
        onSelectionChanged={this.onSelectionChanged}
        focusedRowEnabled={true}
        defaultFocusedRowKey={this.state.currentValue}
      >
        <Column dataField="firstName" caption="Children" />
        <Selection mode="multiple" />
      </DataGrid>
    );
  }

  onSelectionChanged(selectionChangedArgs) {
    console.log(selectionChangedArgs.selectedRowKeys);
    this.setState({
      currentValue:
        (selectionChangedArgs.selectedRowKeys.length &&
          selectionChangedArgs.selectedRowKeys) ||
        [],
    });
    this.props.data.setValue(this.state.currentValue);
  }

  syncDataGridSelection(e) {
    this.setState({
      currentValue: e.value || [],
    });
  }

  render() {
    return (
      <DropDownBox
        ref={this.dropDownBoxRef}
        dropDownOptions={dropDownOptions}
        dataSource={this.props.data.column.lookup.dataSource}
        value={this.state.currentValue}
        onValueChanged={this.syncDataGridSelection}
        displayExpr="firstName"
        valueExpr="childrenId"
        contentRender={this.contentRender}
      />
    );
  }
}

class DaysOfWeekDropDownBoxComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValue: props.data.value || [],
    };
    this.dropDownBoxRef = React.createRef();
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.syncDataGridSelection = this.syncDataGridSelection.bind(this);
    this.contentRender = this.contentRender.bind(this);
  }

  contentRender() {
    return (
      <DataGrid
        dataSource={this.props.data.column.lookup.dataSource}
        remoteOperations={true}
        keyExpr="Value"
        selectedRowKeys={this.state.currentValue}
        hoverStateEnabled={true}
        onSelectionChanged={this.onSelectionChanged}
        focusedRowEnabled={true}
        defaultFocusedRowKey={this.state.currentValue}
      >
        <Column dataField="Name" caption="Days of week" />
        <Selection mode="multiple" />
      </DataGrid>
    );
  }

  onSelectionChanged(selectionChangedArgs) {
    console.log(selectionChangedArgs.selectedRowKeys);
    this.setState({
      currentValue:
        (selectionChangedArgs.selectedRowKeys.length &&
          selectionChangedArgs.selectedRowKeys) ||
        [],
    });
    this.props.data.setValue(this.state.currentValue);
  }

  syncDataGridSelection(e) {
    this.setState({
      currentValue: e.value || [],
    });
  }

  render() {
    return (
      <DropDownBox
        ref={this.dropDownBoxRef}
        dropDownOptions={dropDownOptions}
        dataSource={this.props.data.column.lookup.dataSource}
        value={this.state.currentValue}
        onValueChanged={this.syncDataGridSelection}
        displayExpr="Name"
        valueExpr="Value"
        contentRender={this.contentRender}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Survey.js